/**
 * Runs `task` once the page has loaded (the window's `load` event) and the
 * browser is next idle, for work the page does not need in order to show
 * itself (analytics, session replay): it then never competes with the first
 * paint or with the page's own chunks. Where the browser cannot say it is
 * idle, shortly after `load`.
 */
export default function whenPageSettled(task) {
    const idle = () => {
        if (window.requestIdleCallback) window.requestIdleCallback(() => task(), { timeout: 2000 });
        else setTimeout(task, 200);
    };

    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
}
